<template >
  <div>
    <SearchSection></SearchSection>
    <MainMessage v-if="showMainMessage" ></MainMessage>
    <CategoriesSection > </CategoriesSection>

      <ResultsSection v-if="categoryChange" :questions="questions" ></ResultsSection>

    <CtaSection></CtaSection>
  </div>
</template>

<script>
import SearchSection from "./SearchSection"
import CategoriesSection from "./CategoriesSection"
import MainMessage from "./MainMessage"
import ResultsSection from "./ResultsSection"
import VueScrollTo from 'vue-scrollto'
import CtaSection from "./CtaSection"

export default {
  components: {
    SearchSection,
    CategoriesSection,
    MainMessage,
    ResultsSection,
    CtaSection
  },
  data: () => {
    return {
        showMainMessage: false,
        questions: null,
    }
  },
  created () {
    let locale;
    if(this.$route.params.lang) {
      locale = this.$route.params.lang;
    } else {
      locale = this.$store.state.activeLocale;
    }
    this.$store.dispatch('getQuestionData',locale)
    .then((res) => {
      if(this.$route.hash){
        const hash = this.$route.hash.substr(1)
        let category;
        Object.keys(res).map(function (item) {
          Object.keys(res[item]).map(function (key) {
            if(res[item][key].post_slug.toLowerCase().includes(hash.toLowerCase())){
                  category = item;
              }
          });
        });
        let categoryBlocks = document.getElementsByClassName('category-block');
            let i;
            for(i=0;i<categoryBlocks.length;i++){
                categoryBlocks[i].classList.remove("active");
            }
            let activeElement = document.getElementById(category);
            activeElement.classList.add("active");
        this.$store.dispatch('showResults', category)
        .then(() => {
          let element = document.getElementById('collapse-' + hash);
          element.classList.add("show");
          let elementArrow = document.querySelector("[data-target='#collapse-" + hash + "']")
          elementArrow.setAttribute("aria-expanded", true);
          VueScrollTo.scrollTo(this.$route.hash)
        })
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
    
    if(to.hash){
      setTimeout(function(){
        VueScrollTo.scrollTo(to.hash)
      }, 350)
    }
    
    return next();
  },
  computed: {
    categoryChange: function() {
        return this.$store.state.activeCategory
    },
    localeChange: function() {
      return this.$store.state.activeLocale
    }
  },
  watch: {
		categoryChange (category) {
			this.getQuestionData(category)
    },
    '$route.params.lang': function () {

			let locale = this.$route.params.lang;
			
      this.$store.dispatch('getQuestionData',locale)
      .then(() => {
        this.$store.dispatch('hideResults')
        .then( () => {
          let category = this.$store.state.activeCategory
          this.getQuestionData(category)
        })
      })
						
    }
  }, 
  methods: {
    getQuestionData(category) {
        // console.log(category)
        switch(category) {
          case 'account':
              this.questions = this.$store.getters.accountCategoryData
              break;
          case 'payment':
              this.questions = this.$store.getters.paymentCategoryData
              break;
          case 'content':
              this.questions = this.$store.getters.contentCategoryData
              break;
        }
        // this.uniqueReRenderNumber++;
    }
  }
  
}
</script>

<style>
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: all 0.2s ease-in;
  }
  .fade-active {
  }
  .fade-leave-active {
    transition: all 0.2s ease-in;
    opacity: 0;
  }
</style>
